module.exports = __webpack_public_path__ + "static/media/EmptyState.4c1afe38.svg";